module.exports = __webpack_public_path__ + "img/LOGO_PNG_Big-removebg-preview.befb82d0.png";